module.exports = __webpack_public_path__ + "static/media/check-box.02e3f4f0.svg";